module.exports = __webpack_public_path__ + "img/eabiao.52e4681d.jpg";